declare namespace $ {

	type $mol_view__sub_bog_bzrl_app_benefit_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_benefit_2 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_benefit['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_bzrl_app_benefit_3 = $mol_type_enforce<
		ReturnType< $bog_bzrl_app_benefit['description'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $bog_bzrl_app_benefit extends $mol_view {
		icon( ): any
		Icon( ): $mol_view
		title( ): string
		Title( ): $mol_paragraph
		description( ): string
		Description( ): $mol_paragraph
		sub( ): readonly(any)[]
	}
	
	export class $bog_bzrl_app_benefit_owners extends $bog_bzrl_app_benefit {
		Icon_owners( ): $mol_icon_home_account
		icon( ): ReturnType< $bog_bzrl_app_benefit_owners['Icon_owners'] >
		title( ): string
		description( ): string
	}
	
	export class $bog_bzrl_app_benefit_verified extends $bog_bzrl_app_benefit {
		Icon_verified( ): $mol_icon_magnify
		icon( ): ReturnType< $bog_bzrl_app_benefit_verified['Icon_verified'] >
		title( ): string
		description( ): string
	}
	
	export class $bog_bzrl_app_benefit_secure extends $bog_bzrl_app_benefit {
		Icon_secure( ): $mol_icon_lock_outline
		icon( ): ReturnType< $bog_bzrl_app_benefit_secure['Icon_secure'] >
		title( ): string
		description( ): string
	}
	
}

//# sourceMappingURL=benefit.view.tree.d.ts.map